import React, { forwardRef } from 'react';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';

import './styles/stat.scss';

type Props = {
  value?: React.ReactNode;
  classes?: Argument;
};
export const StatValue: React.FC<Props> = forwardRef<HTMLSpanElement, Props>(
  (props, ref) => {
    const { value = '--', classes = 'purple' } = props;
    return (
      <span className={cs('stat-value', classes)} ref={ref}>
        {value}
      </span>
    );
  }
);
